module.exports = __webpack_public_path__ + "logos/logo-teamwork.379c9c.svg";